<template>
<!-- 为灵活信号设置页面提供修改信号的modal页面，根据信号的name展示不同的修改选项 -->
  <div>
    <Row>
      <Modal
        v-model="m_open_modal_switch"
        :title="this.get_modal_title()"
        :loading="loading_status"
        @on-ok="set_ok"
        @on-cancel="set_cancel"
        @on-visible-change="set_changed"
      >
        <p slot="header" class="demo-drawer-hearde">
          <Icon type="information-circled"></Icon>
          <span>{{ this.get_modal_title() }}</span>
        </p>
        <Row>
          <Col span="20" offset="2">
          <div v-if="this.m_type === 'select_early_report_msg'">
            <Form ref="select_early_report_ref" label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="选定预警">
                <Select v-model="select_early_report_id" filterable>
                  <Option v-for="item in get_select_early_report_list()" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Form>
            </div>
            <!-- MA -->
            <div v-else-if="this.m_type === 'setting_msg' && this.select_early_report.type === '-2'">
              <Form ref="setting_msg" label-position="left" :label-width="140" :label-colon="true" :model='select_early_report' :rules="strategy_msg_form_rules">
                <FormItem label="预警指标名" prop="name">
                    <Input
                      v-model="select_early_report.name"
                      clearable
                    ></Input>
                </FormItem>
                <FormItem label="短MA参数">
                    <Slider
                      v-model="select_early_report.paras[0]"
                      :step="1"
                      :max="1500"
                      :min="1"
                      show-input
                    ></Slider>
                </FormItem>
                <FormItem label="长MA参数">
                    <Slider
                      v-model="select_early_report.paras[1]"
                      :step="1"
                      :max="1500"
                      :min="1"
                      show-input
                    ></Slider>
                </FormItem>
                <FormItem label="重采样参数(min)">
                    <Input
                      v-model="select_early_report.paras[2]"
                      style="width:150px"
                      readonly
                    ></Input>
                </FormItem>
                <FormItem label="预警推送开关">
                    <i-switch
                      v-model="m_paras[3]"
                      size="large"
                      true-color="#13ce66" 
                      false-color="#ff4949"
                      false-value='f'
                      true-value='t'
                    >
                    <span slot="open">打开</span>
                    <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <FormItem label="预警参数">
                  <Tooltip content="当指标状态新转为value定义时, 发出告警" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                    <Select v-model="m_paras[4]" style="width:150px">
                      <Option v-for="item in [{value:'all',label:'All'}, {value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                  </Tooltip>
                </FormItem>
              </Form>
            </div>
            <!-- GUPPY -->
            <div v-else-if="this.m_type === 'setting_msg' && this.select_early_report.type === '-1'">
              <Form ref="setting_msg" label-position="left" :label-width="140" :label-colon="true" :model='select_early_report' :rules="strategy_msg_form_rules">
                <FormItem label="预警指标名" prop="name">
                    <Input
                      v-model="select_early_report.name"
                      clearable
                    ></Input>
                </FormItem>
                <FormItem label="回顾时长">
                    <Select v-model="select_early_report.paras[0]" style="width:150px">
                      <Option v-for="item in guppy_interval[select_early_report.paras[1]]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="时长单位">
                  <Tooltip content="m=分钟, h=小时" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                    <Select v-model="select_early_report.paras[1]" style="width:150px" @on-change="m_or_h_change">
                      <Option v-for="item in [{value:'m',label:'m'}, {value:'h',label:'h'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                  </Tooltip>
                </FormItem>
                <FormItem label="预警推送开关">
                    <i-switch
                      v-model="m_paras[3]"
                      size="large"
                      true-color="#13ce66" 
                      false-color="#ff4949"
                      false-value='f'
                      true-value='t'
                    >
                    <span slot="open">打开</span>
                    <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <FormItem label="预警参数">
                  <Tooltip content="当指标状态新转为value定义时, 发出告警" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                    <Select v-model="m_paras[4]"  style="width:150px">
                      <Option v-for="item in [{value:'all',label:'All'}, {value:'buy',label:'Buy'}, {value:'stable',label:'Stable'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                  </Tooltip>
                </FormItem>
              </Form>
            </div>
            <!-- BinanceBigData -->
            <div v-else-if="this.m_type === 'setting_msg' && this.select_early_report.type === '-3'">
              <Form ref="setting_msg" label-position="left" :label-width="140" :label-colon="true" :model='select_early_report' :rules="strategy_msg_form_rules">
                <FormItem label="预警指标名" prop="name">
                    <Input
                      v-model="select_early_report.name"
                      clearable
                    ></Input>
                </FormItem>
                <FormItem label="预警推送开关">
                    <i-switch
                      v-model="m_paras[3]"
                      size="large"
                      true-color="#13ce66" 
                      false-color="#ff4949"
                      false-value='f'
                      true-value='t'
                      disabled
                    >
                    <span slot="open">打开</span>
                    <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <FormItem label="预警参数">
                  <Tooltip content="当指标状态新转为value定义时, 发出告警" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                    <Select v-model="m_paras[4]"  style="width:150px">
                      <Option v-for="item in [{value:'all',label:'All'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                  </Tooltip>
                </FormItem>
              </Form>
            </div>
            <!-- 单击确认后，修改/创建策略 -->
            <div v-else-if="this.m_type === 'create_or_alter_strategy'">
              <Form ref="create_or_alter_strategy" label-position="left" :label-width="140" :label-colon="true" :model='select_early_report' :rules="strategy_msg_form_rules_create">
                <FormItem label="预警策略名" prop="name">
                    <Input
                      v-model="select_early_report.name"
                      clearable
                    ></Input>
                </FormItem>
              </Form>
            </div>
            <div v-else>
            </div>
          </Col>
        </Row>
      </Modal>
    </Row>
  </div>
</template>
<script>
export default {
  name: "early_report_render_modal_view",
  data() {
    return {
      timer:null,
      // 用户选择的预警ID
      select_early_report_id:null,
      select_early_report:{
        "early_report_name":"",
        
        "name":"",
        "type":"",
        "paras":[],
      },
      loading_status:true,
      m_open_modal_switch:false,
      m_type:"",

      //信号、止盈止损等输入框体的提示
      m_tooltip_delay:3000,
      m_tooltip_max_width:200,
      m_tooltip_placement:"right",

      guppy_interval:{
        "m":[
          {value: 30,label: '30'},
        ],
        "h":[
          {value: 1,label: '1'},
          {value: 2,label: '2'},
          {value: 4,label: '4'},
        ]
      },
      strategy_msg_form_rules:{
        name: [
            { required: true, message: '预警指标名不能为空', trigger: 'change', type:"string" },
            { validator: this.validate_custum_check, trigger: 'change' }
        ],
      },
      strategy_msg_form_rules_create:{
        name: [
            { required: true, message: '策略名不能为空', trigger: 'change', type:"string" },
            { validator: this.validate_custum_check, trigger: 'change' }
        ],
      },
    }
  },
  props: {
    paras: {
      type: [Array, Object],
    },
    open_modal_switch:{
      type: Boolean,
      default: false
    },
    uuid: {
      type: String,
      default: ""
    },
    modal_type: {
      type: String,
      default: ""
    },
  },
  methods:{
    validate_custum_check: function(rule, value, callback) {
        if (value.indexOf("_") != -1 ) {
            callback(new Error('不允许包含下划线"_"'));
        } else {
            callback();
        }
    },
    set_ok_for_type_setting_msg: function() {
      this.$refs["setting_msg"].validate((valid) => {
          if (valid) {
            this.loading_status = true
            this.m_paras[2] = this.select_early_report["paras"].join("-")
            this.m_paras[1] = this.select_early_report["name"]
            this.$emit("modal_click", {
              "paras":this.m_paras,
              "uuid":this.uuid,
              "m_type":this.m_type,
              "mode":"ok",
            })
          } else {
            setTimeout(() => {
              this.loading_status = false;
              this.$nextTick(()=>{
                this.loading_status = true;
              })
            }, 200);
          }
          return null
      }, (error) => {
        console.log("检验函数遇到错误")
        console.log(error)
      })
    },
    set_ok_for_create_or_alter_strategy: function() {
      this.$refs["create_or_alter_strategy"].validate((valid) => {
          if (valid) {
            this.loading_status = true
            this.m_paras[0] = this.select_early_report["name"]
            this.$emit("modal_click", {
              "paras":this.m_paras,
              "m_type":this.m_type,
              "mode":"ok",
            })
          } else {
            setTimeout(() => {
              this.loading_status = false;
              this.$nextTick(()=>{
                this.loading_status = true;
              })
            }, 200);
          }
          return null
      }, (error) => {
        console.log("检验函数遇到错误")
        console.log(error)
      })
    },
    set_ok: function() {
      if (this.m_type === "select_early_report_msg") {
        this.select_early_report["id"] = this.select_early_report_id
        this.$emit("modal_click", {
          "paras":this.m_paras,
          "uuid":this.uuid,
          "m_type":this.m_type,
          "select_early_report":this.select_early_report,
          "mode":"ok",
        })
      } else if (this.m_type === "setting_msg") {
        this.set_ok_for_type_setting_msg()
      } else if (this.m_type === "create_or_alter_strategy") {
        this.set_ok_for_create_or_alter_strategy()
      }else {
        this.$emit("modal_click", {
          "paras":this.m_paras,
          "uuid":this.uuid,
          "m_type":this.m_type,
          "mode":"ok",
        })
      }
    },
    set_cancel: function() {
      this.$emit("modal_click", {
        "mode":"cancel",
      })
    },
    set_changed: function(value) {
      if (value == false) {
        setTimeout(() => {
          this.m_type = ""
        }, 250);
      }
    },
    get_select_early_report_list: function() {
      let early_report_list = []
      // 根据后台的数据，展示所有可以被选择的预警ID
      early_report_list.push({
          "value":-1,
          "label":"创建新的预警",
        })
      for (var key in this.m_paras) {
        var con = this.m_paras[key]
        // con[4]存储着预警ID的运行状态, 1为正在运行时
        if (con[4].toString() != "1") {
          early_report_list.push({
            "value":con[0],
            "label":con[0]+"号:" + con[1],
          })
        }
      }
      return early_report_list
    },
    get_modal_title: function() {
      if (this.m_type === 'select_early_report_msg') {
        return "录入预警ID"
      } else if (this.m_type === 'setting_msg') {
        return "修改" + this.paras[1] + "预警指标"
      } else if (this.m_type === 'create_or_alter_strategy') {
        if (this.paras[0] === "-1") {
          return "创建新的预警策略"
        } else {
          return "修改" + this.paras[1] + "号预警策略"
        }
      }
      return ""
    },
    m_or_h_change: function(){
      if (this.select_early_report.paras[0] === "h") {
        this.select_early_report.paras[0] = 1
      } else {
        this.select_early_report.paras[0] = 30
      }
    },
    // 设定循环执行的内容
    setTimer: function(interval) {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          // this.get_symbol_list()
        }, interval);
      }
    },
  },
  mounted: function() {
    
  },
  created: function() {
    clearInterval(this.timer);
    this.timer = null;
    // 5分钟一刷新
    this.setTimer(5 * 60 * 1000);
  },
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  },
  watch: {
    open_modal_switch(old_value) {
      // 避免直接由内部修改props的情况
      this.m_open_modal_switch = this.open_modal_switch
      if (this.m_open_modal_switch == true) {
        // 在打开modal的时候初始化参数
        this.m_paras = JSON.parse(JSON.stringify(this.paras))
        this.m_type = this.modal_type
        if (this.m_type === 'setting_msg') {
          // 录取本次设置的预警指标信息
          this.select_early_report["type"] = this.m_paras[0].toString()
          this.select_early_report["name"] = this.m_paras[1]
          this.$set(this.select_early_report, "name", this.m_paras[1])
          // MA双均线
          if (this.select_early_report.type === '-2') {
            //"-1_MA-1_66-490-3_f_buy_08716b92-f710-4d66-a170-06f089f611e0"
            let tmp = this.m_paras[2].split("-")
            tmp[0] = Number(tmp[0])
            tmp[1] = Number(tmp[1])
            tmp[2] = Number(tmp[2])
            this.select_early_report["paras"] = tmp
          } else if (this.select_early_report.type === '-1') {
            //"-1_GUPPY-2_2-h_t_all_08716b92-f710-4d66-a170-06f089f611e4"
            let tmp = this.m_paras[2].split("-")
            tmp[0] = Number(tmp[0])
            tmp[1] = tmp[1].toString()
            this.select_early_report["paras"] = tmp
          }
        } else if (this.m_type === 'create_or_alter_strategy') {
          this.select_early_report["name"] = this.m_paras[0]
        }
      } 
    },
  }
}
</script>
<style>
.demo-drawer-hearde {
  text-align:center;
}
</style>